import * as yup from 'yup';
import { translate } from '../../../shared/i18n';

export const schemaInput = yup.object().shape({
  type: yup
    .string()
    .required(translate('modelsFormsCreateEdit.validation.inputTypeRequired')),
  label: yup
    .string()
    .required(translate('modelsFormsCreateEdit.validation.inputLabelRequired')),
});
